<template>
  <div id="video">
    <navigation />
    <div class="video-wrapper">
      <mdb-container class="mx-auto video-container">
        <video class="video-fluid z-depth-1 mx-auto" poster="https://thitchstorage.blob.core.windows.net/thitchimage/Thitch_filler.jpg" controls="controls" preload="auto" >
          <source :src="data.VideoUri" />
        </video>
      </mdb-container>
    </div> 
    <mdb-container class="py-3 mx-auto w-100">
      <div class="text-left">
        <div>
          <h2>{{data.VideoTitel}}</h2>
        </div>
        <div class="description-box">
          <p>
            {{data.VideoDescription}}
          </p>
        </div>
      </div>
      <span id="videoUri">{{externalUrl}}</span>
      <mdb-btn color="#f57f17 yellow darken-4" icon="fas fa-copy" v-on:click="copyUrl()" type="submit">Copy Video Url for External use</mdb-btn>
    </mdb-container>
  </div>
</template>

<script>
import { mdbContainer, mdbBtn } from "mdbvue";
import navigation from "@/components/navigation";

export default {
  name: "video",
  components: {
    navigation,
    mdbContainer,
    mdbBtn
  },
  data() {
    return {
      data: null,
      externalUrl: null
    };
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.replace({ name: "login" });
    }
  },
  created() {
    this.getVideo(this.$route.params.id);
  },
  methods: {
    getVideo: async function(videoId) {
      console.log("id", videoId);
      this.externalUrl = window.location.origin + '/video-no-auth/' + videoId;
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      };
      let params = {
        videoId: videoId
      };

      let query = Object.keys(params)
        .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      const url =
        "https://thitch.azurewebsites.net/api/GetVideoByGuid?code=muEp7xqSEawcfs7xcIkXXW0iKhxvsQBC2aREu3XziE9tQ3xQcdCfZw==&" +
        query;
      const res = await fetch(url, requestOptions);
      const data = await res.json();
      this.data = data;
      console.log("res video ", this.data);
    },
    copyUrl() {
        var str = document.getElementById('videoUri');
        window.getSelection().selectAllChildren(str);
        document.execCommand("Copy");
    }
  }
};
</script>

<style scoped>
#home {
  background-color: #ffffff;
  border: 1px solid #cccccc;
}
#videoUri {
  padding: 13px;
  background-color: #fdd835;
  border-radius: 10px;
}
.video-container {
  background: #b6b6b6;
  display: flex;
}
.video-fluid {
  margin: 0 auto;
  max-height: 720px;
}
.video-wrapper {
  background: #b6b6b6;
}
h2 {
    margin-bottom: 20px;
    margin-top: 20px;
    font-weight: 600;
}
</style>